var Y = Object.defineProperty;
var R = (i, s, t) => s in i ? Y(i, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[s] = t;
var f = (i, s, t) => R(i, typeof s != "symbol" ? s + "" : s, t);
import { jsx as e, jsxs as c } from "react/jsx-runtime";
import * as g from "react";
import m from "react";
import { message as S, Row as D, Col as o, Input as u, Select as v, Button as k } from "antd";
import d from "dayjs";
import { u as y } from "../../styled-components.browser.esm-BFmoFexH.js";
import { IconContainer as x } from "@biron-data/react-components";
import { F as T } from "../../TrashIcon-LVtkVuzL.js";
function V(i, s) {
  return /* @__PURE__ */ g.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: s
  }, i), /* @__PURE__ */ g.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const b = g.forwardRef(V);
class L extends m.Component {
  constructor(t) {
    super(t);
    f(this, "months");
    f(this, "changeTarget", (t, n) => {
      const { value: r = [] } = JSON.parse(JSON.stringify(this.props));
      if (!isNaN(parseFloat(n))) {
        const l = r.findIndex(({ refDate: h }) => h === t);
        l !== -1 && (r[l].value = parseFloat(n), this.props.onChange(r));
      }
    });
    f(this, "deleteTarget", (t) => {
      const { value: n = [] } = JSON.parse(JSON.stringify(this.props)), r = n.findIndex(({ refDate: l }) => l === t);
      r !== -1 && n.splice(r, 1), this.props.onChange(n);
    });
    f(this, "addTarget", () => {
      const t = [...this.props.value || []], n = d().year(this.state.draftYear).month(this.state.draftMonth).endOf("month").format("YYYY-MM-DD");
      t.findIndex(({ refDate: l }) => l === n) === -1 ? (t.push({ refDate: n, value: this.state.draftValue }), this.props.onChange(t)) : S.error(this.props.languageResolver.get("configuration-chart-target-duplicate-entry"));
    });
    this.state = {
      draftMonth: d().get("month"),
      draftYear: d().get("year"),
      draftValue: 0
    }, this.months = new Array(12).fill().map((n, r) => ({
      month: r,
      label: d().month(r).format("MMMM")
    }));
  }
  render() {
    const { value: t = [], getPopupContainer: n } = this.props, { addTarget: r, changeTarget: l, deleteTarget: h } = this, { draftMonth: C, draftValue: M, draftYear: w } = this.state;
    return /* @__PURE__ */ e(F, { children: /* @__PURE__ */ c(D, { gutter: [10, 10], children: [
      /* @__PURE__ */ e(o, { span: 8, children: this.props.languageResolver.get("configuration-label-period") }),
      /* @__PURE__ */ e(o, { span: 13, offset: 1, children: this.props.languageResolver.get("configuration-chart-target-value") }),
      t.map((a) => /* @__PURE__ */ c(m.Fragment, { children: [
        /* @__PURE__ */ e(o, { span: 4, children: d(a.refDate).format("MMMM") }),
        /* @__PURE__ */ e(o, { span: 4, children: d(a.refDate).format("YYYY") }),
        /* @__PURE__ */ e(o, { span: 7, offset: 1, children: /* @__PURE__ */ e(
          u,
          {
            type: "number",
            step: "any",
            defaultValue: a.value,
            onChange: (p) => l(a.refDate, p.target.value)
          }
        ) }),
        /* @__PURE__ */ e(o, { span: 1, offset: 1, children: /* @__PURE__ */ e(x, { clickable: !0, children: /* @__PURE__ */ e(
          T,
          {
            onClick: () => h(a.refDate)
          }
        ) }) }),
        /* @__PURE__ */ e(o, { span: 6 })
      ] }, a.refDate)),
      /* @__PURE__ */ e(o, { span: 4, children: /* @__PURE__ */ e(
        v,
        {
          style: { width: "100%" },
          getPopupContainer: n,
          defaultValue: C,
          virtual: !1,
          onChange: (a) => {
            this.setState({ draftMonth: a });
          },
          children: this.months.map(({ label: a, month: p }) => /* @__PURE__ */ e(v.Option, { value: p, children: a }, p))
        }
      ) }),
      /* @__PURE__ */ e(o, { span: 4, children: /* @__PURE__ */ e(u, { type: "number", defaultValue: w, onChange: (a) => {
        this.setState({ draftYear: a.target.value });
      } }) }),
      /* @__PURE__ */ e(o, { span: 7, offset: 1, children: /* @__PURE__ */ e(u, { type: "number", step: "any", defaultValue: M, onKeyDown: (a) => {
        a.key === "Enter" && r();
      }, onChange: (a) => {
        this.setState({ draftValue: a.target.value });
      } }) }),
      /* @__PURE__ */ e(o, { span: 24, children: /* @__PURE__ */ c(O, { onClick: r, children: [
        /* @__PURE__ */ e(x, { margin: 10, children: /* @__PURE__ */ e(b, {}) }),
        this.props.languageResolver.get("configuration-add-target")
      ] }) })
    ] }) });
  }
}
const O = y(k)`
  display: flex;
`, F = y.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
export {
  L as default
};
//# sourceMappingURL=TargetSelector.js.map
